import { render, staticRenderFns } from "./TicketSales.vue?vue&type=template&id=5d175c10&scoped=true&%3Aelement-loading-text=%24locale('global.loading')&element-loading-spinner=el-icon-loading&"
import script from "./TicketSales.vue?vue&type=script&lang=js&"
export * from "./TicketSales.vue?vue&type=script&lang=js&"
import style0 from "./TicketSales.vue?vue&type=style&index=0&id=5d175c10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d175c10",
  null
  
)

export default component.exports